export default __webpack_public_path__ + "static/media/office.7ff08cd9.mp4";